const homeFastUpdate = setInterval(() => {
    const homeFastShadow = document.querySelector(".fast-simon-new-upsell-1734449029734447")?.shadowRoot;
    const homeDots = homeFastShadow.querySelector(".dotsContainer");
    if(homeDots) {
        const homeDotDiv = homeDots.parentElement;
        homeDotDiv.innerHTML = `
        <a href="/collections/all" class="fast-simon-shop-all">Shop All</a>
        <style>
            .fast-simon-shop-all {
                font-size: 20px;
                font-weight: 600;
                font-style: normal;
                letter-spacing: .5px;
                font-family: var(--heading-font-family);
                color: black;
                text-decoration: none;
                text-transform: uppercase;
                background-color: white;
                padding: 8px 11px;
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
                line-height: normal;
                transition: transform var(--duration-default) var(--ease-out-slow);
                margin-bottom: 30px;
            }
            .fast-simon-shop-all:after {
                content: url(https://mephistousa.com/cdn/shop/t/11/assets/black-arrow.svg);
                margin-left: 30px;
                position: relative;
                top: -2px;
                transition: box-shadow 100ms ease;
            }
            .fast-simon-shop-all:hover {
                transform: translateY(-.25rem);
                background-color: #000;
                color: #FFF;
            }
            .fast-simon-shop-all:hover:after {
                content: url(https://mephistousa.com/cdn/shop/t/11/assets/white-arrow.svg);
            }
        </style>
        `
        clearInterval(homeFastUpdate);
    }
}, 1000);